/**
 * SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
 * Copyright (C) 2021 SuiteCRM Ltd.
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License version 3 as published by the
 * Free Software Foundation with the addition of the following permission added
 * to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
 * IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
 * WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 * In accordance with Section 7(b) of the GNU Affero General Public License
 * version 3, these Appropriate Legal Notices must retain the display of the
 * "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
 * feasible for technical reasons, the Appropriate Legal Notices must display
 * the words "Supercharged by SuiteCRM".
 */

import {Injectable} from '@angular/core';
import {SeriesResult} from '../../../../common/containers/chart/chart.model';
import {ObjectMap} from '../../../../common/types/object-map';
import {SeriesTraverser, SeriesVisitor, SeriesVisitorMap} from './series-traverser.service';
import {DataTypeSeriesMapper} from './data-type-mapper/data-type.series-mapper';

@Injectable({
    providedIn: 'root'
})
export class SeriesMapper {

    registry: SeriesVisitorMap = {};

    constructor(
        protected traverser: SeriesTraverser,
        protected dataTypeMapper: DataTypeSeriesMapper
    ) {
        this.addMapper('data-type-unit-converter', dataTypeMapper);
    }

    addMapper(unitType: string, mapper: SeriesVisitor): void {
        this.registry[unitType] = mapper;
    }

    map(result: SeriesResult, mapperType: string, options?: ObjectMap): void {

        const mapper = this?.registry[mapperType] ?? null;

        if (!mapper) {
            return;
        }

        this.traverser.traverse(result, mapper, options);
    }
}
